export const menuItem = (name, path, component) => ({
  name,
  path,
  component,
});

export const menuGroup = (name, path, group) => ({
  name,
  path,
  group,
});

export const menuSection = (name, path, items) => ({
  name,
  path,
  items,
});
